import PropTypes from 'prop-types';
import PermissionGroupListView from '../../components/PermissionGroupListView';

PermissionGroupListScreen.propTypes = {
  role: PropTypes.string,
  subRole: PropTypes.string,
};

function PermissionGroupListScreen({ role, subRole }) {
  // MARK: ---- PROPERTIES ----
  // const { user } = useSelector((state) => state.auth);
  // const isAdmin =
  //   user?.role === ChargeConstants.UserRole.ADMIN ||
  //   user?.role === ChargeConstants.UserRole.OPERATOR;
  // const isAgency = user?.role === ChargeConstants.UserRole.AGENCY;
  // const role = user?.role;
  // const subRole = isAgency ? user?.agency?.primaryRole : null;

  return (
    <div className="container-fluid px-4 my-4">
      <PermissionGroupListView showFullUI={true} role={role} subRole={subRole} />
    </div>
  );
}

export default PermissionGroupListScreen;
